<wiz-vgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  <wiz-hgroup width="100%" height="100%">

  <wiz-vgroup width="250px" height="100%" class="section-container"><!-- zone champs libres & filtre -->
    <wiz-hgroup  width="100%">
      <wiz-label width="100%" [wizLabel]="'$.freedata.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
      <wiz-icon  style="cursor: pointer;" class="image-purple"  [wizTooltip]="'$.common.delete.$'"  (click)="onDeleteClick()">delete </wiz-icon>
    </wiz-hgroup>
    <wiz-list
      #freeList
      id="freeList"
      height="100%"
      width="100%"
      [wizItemRenderer]="renderer"
      [wizDataProvider]="dataSource"
      [wizLabelField]="'fullCode'"
      [dragEnabled]="true"
    ></wiz-list>
    <filter-component #mainFilter> </filter-component>
  </wiz-vgroup>

  <wiz-vgroup #vgDetailZone width="100%" height="100%"> <!-- zone détail : poser les champs -->  
 
    <wiz-hgroup width="100%" height="100%">
        <!-- champs lignes (structure de clé de la colonne de gauche) -->
        <wiz-vgroup width="200px" height="100%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-line</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.calendar.key.fields.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list #lstRow
          id="lstRow" width="100%" height="100%"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"></wiz-list>
      </wiz-vgroup>

      <!-- champs filtre -->
      <wiz-vgroup width="200px" height="100%" class="section-container"> 
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-filters</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.calendar.filter.fields.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        
        <wiz-list #lstFilter
        id="lstFilter" width="100%" height="100%"
        [wizItemRenderer]="renderer"
        [dragEnabled]="true"
        [dropEnabled]="true"
        [enableSelfReorder]="true"
        [shopDropIndicator]="true"
        [dragMove]="true"></wiz-list>   
      </wiz-vgroup>   


      <!-- champs colonnes (dates bornes) uniquement les champs de type date -->
      <wiz-vgroup width="100%" height="100%" class="section-container"> 
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-calendar</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.calendar.measure.fields.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          
          <wiz-list #lstColumn
          id="lstColumn" width="100%" height="100%"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"></wiz-list>   
        </wiz-vgroup>   
    </wiz-hgroup> 
  

    <wiz-vgroup width="100%" height="100%" class="section-container"> <!-- champs datas pour form -->
      <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
        <wiz-icon class="image-purple">icon-formula</wiz-icon>
        <wiz-label [wizLabel]="'$.pivot.edit.form.fields.$'" class="smallTitleLabel"></wiz-label>
      </wiz-hgroup>

      <wiz-vgroup width="100%" height="100%"><!-- zone lignes et datas -->
        <freedata-gridster wizDragDrop [wizDropEnabled]="true" width="100%" height="100%" 
        [model]="model"
        [freedataValue]="fakeFreeDataValue" (widgetsChanged)="onWidgetsChanged($event)" 
        [widgets]="widgets" [templatingMode]="true"></freedata-gridster>
      </wiz-vgroup>
    </wiz-vgroup>


  <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
    <wiz-vgroup width="100%">
      <wiz-checkbox #cbShowDeleteCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
      <wiz-checkbox #cbShowDeleteRecurseCol [visible]="false" [wizLabel]="'$.pivot.edit.show.delete.recurse.$'"></wiz-checkbox>
      <wiz-checkbox #cbShowSelectCol [visible]="false" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
      <wiz-checkbox #cbSelectUnique [visible]="false" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
    </wiz-vgroup>
    <wiz-button
      #btnSave
      width="150px"
      (click)="doValid()"
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      width="150px"
      (click)="doCancel()"
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
<!-- fin zone détail -->
</wiz-hgroup>
